import Localbase from 'localbase' // https://github.com/dannyconnell/localbase
import { ListNames } from '../config/configuration'

const db = new Localbase('db')

// Add all lists to be stored in IndexedDB localbase here
const INDEXED_DB_LIST_TITLES = {
  KBArticles: ListNames.KNOWLEDGEGRAPH,
  MasterList: ListNames.MASTERLIST,
  CommonMetadata: ListNames.COMMON_METADATA
}

export { db, INDEXED_DB_LIST_TITLES }
